import { render, staticRenderFns } from "./CharacterDeletingForm.vue?vue&type=template&id=be74684a&lang=pug&"
import script from "./CharacterDeletingForm.vue?vue&type=script&lang=js&"
export * from "./CharacterDeletingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterDeletingForm.vue"
export default component.exports